import Api from './api';

const RHService = {
    listarConcursos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/concurso/listar',
            params: params
        })
        return response
    },
    buscarConcurso: (params) => {
        const response = Api.get(`/concurso/buscar?${params}`)
        return response
    },
    listarEstagiarios: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/estagiario/listar',
            params: params
        })
        return response
    },
    buscarEstagiario: (params) => {
        const response = Api.get(`/estagiario/buscar?${params}`)

        return response
    },
    listarTerceirizados: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/terceirizado/listar',
            params: params
        })
        return response
    },
    buscarTerceirizados: (params) => {
        const response = Api.get(`/terceirizado/buscar?${params}`)
        return response
    }
}

export default RHService;